import React from 'react';
import { APITypes } from '../../../primary-record-types';
import OrganizationDetailsForm from '../OrganizationDetailsForm';

export type FormValue = APITypes.organizationService.CreateOrganizationRequest;

export type CreateOrganizationFormOwnProps = {
    onSubmit: (values: FormValue) => void;
    isDisabled?: boolean;
};

const defaultValues: FormValue = {
    name: '',
    description: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipCode: '',
    email: '',
    phoneNumber: '',
    faxNumber: '',
    url: '',
    isPubliclyListed: true,
    avatar: {
        type: 'not-modified',
    },
    logo: {
        type: 'not-modified',
    },
};

export type CreateOrganizationFormProps = CreateOrganizationFormOwnProps;

const CreateOrganizationForm: React.FC<CreateOrganizationFormProps> = ({ onSubmit, isDisabled }) => {
    return (
        <OrganizationDetailsForm
            onSubmit={(values) =>
                onSubmit({
                    ...values,
                    brandingPrimaryColor: values.brandingPrimaryColor || undefined,
                    brandingSecondaryColor: values.brandingSecondaryColor || undefined,
                })
            }
            isDisabled={isDisabled}
            initialValues={defaultValues}
            isNewOrganization
        />
    );
};

export default React.memo(CreateOrganizationForm);
